import Phaser from "phaser";
export default class GameWinScene extends Phaser.Scene
{
    constructor()
    {
        super('game-win-scene')
    }

    init()
    {   
        this.homeButton = undefined
    }

    preload()
    {
        this.load.image('gameWinBackground', 'images/background win.jpg')
        this.load.image('gameWin','images/gameWin.jpg')
        this.load.image('homeButton', 'images/HomeButton.png')
        this.load.image('outro','images/outro.png')
    }

    create()
    {
        
        this.add.image(960,600,'gameWinBackground').setScale(1.2)
        this.add.image(980,450,'gameWin').setScale(1.5).setAlpha(5)
        this.add.image(1720,885,'outro').setScale(1.2).setAlpha(3)
        this.homeButton = this.add.image(970,900,'homeButton').setScale(0.25).setInteractive()
        this.homeButton.once ('pointerup',()=>{this.scene.start('start-scene')},this)

        this.add.text(960,1000,'REPLAY? CLICK THE BUTTON ABOVE').setOrigin().setScale(2)

    }


}